/*
 * XtremeSkins dark product test: mobile jump-to-preview and Custom gallery arrows.
 * Presentation only: never changes variant values, basket data or the selected image.
 */
(function () {
  'use strict';

  if (window.__xsMobileProductPreviewInstalled) return;
  window.__xsMobileProductPreviewInstalled = true;

  var rootSelector = 'product-info.product-section';
  var mobile = window.matchMedia('(max-width: 749px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var pending = new WeakMap();

  function designSelector(root) {
    var selects = root.querySelectorAll('.product__info-container variant-selects select');
    return Array.from(selects).find(function (select) {
      return Array.from(select.options).some(function (option) {
        return option.value.trim().toLowerCase() === 'custom';
      });
    });
  }

  function syncGalleryArrows(root) {
    if (!root) return;
    var picker = designSelector(root);
    var customSelected = !!picker && picker.value.trim().toLowerCase() === 'custom';
    root.classList.toggle('xs-custom-design-active', customSelected);
  }

  function jumpToImage(root) {
    if (!mobile.matches || !root || !root.isConnected) return;
    var gallery = root.querySelector('media-gallery[id^="MediaGallery-"]');
    if (!gallery || !gallery.getBoundingClientRect().height) return;

    var margin = parseFloat(window.getComputedStyle(gallery).scrollMarginTop) || 0;
    var destination = window.scrollY + gallery.getBoundingClientRect().top - margin;
    if (Math.abs(window.scrollY - destination) < 16) return;

    gallery.scrollIntoView({
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }

  function forget(root) {
    var previous = pending.get(root);
    if (!previous) return;
    window.clearTimeout(previous.fallback);
    window.clearTimeout(previous.afterUpdate);
    window.clearTimeout(previous.expiry);
    pending.delete(root);
  }

  function queueUserJump(root, fromVariantPicker) {
    forget(root);
    var entry = { fallback: null, afterUpdate: null, expiry: null };
    pending.set(root, entry);

    // Custom material overlays do not always trigger a Shopify variant request.
    // Native variants wait for afterVariantChanged so the image is updated before scrolling.
    entry.fallback = window.setTimeout(function () {
      if (pending.get(root) === entry) jumpToImage(root);
    }, fromVariantPicker ? 1100 : 200);

    // Leave a short window for a slow variant response to correct focus after updating.
    entry.expiry = window.setTimeout(function () {
      if (pending.get(root) === entry) forget(root);
    }, 3500);
  }

  document.addEventListener('change', function (event) {
    var control = event.target;
    if (!(control instanceof Element)) return;

    var root = control.closest(rootSelector);
    if (!root) return;

    var variantControl = control.matches(
      'variant-selects select, variant-selects input[type="radio"], variant-radios input[type="radio"]'
    );
    var materialControl = control.matches('#CustomizationViews select');
    var logoOrCaseToggle = control.matches('#CustomizationViews input[type="checkbox"]');

    if (!variantControl && !materialControl && !logoOrCaseToggle) return;

    // Switching Full Colour / Custom changes the mode, not the colour.
    var isDesignMode = variantControl && (
      control === designSelector(root) ||
      (control.name || '').toLowerCase().includes('choose your design')
    );

    // Keep Custom-mode gallery arrows in sync, including synthetic updates.
    if (variantControl) syncGalleryArrows(root);

    // Do not jump for mode switches, logo cut-out or case checkboxes.
    // Cancel any pending earlier scroll so it cannot fire after a mode change.
    if (isDesignMode || logoOrCaseToggle) {
      forget(root);
      return;
    }

    // Only human-initiated style / material changes should scroll on mobile.
    if (event.isTrusted && mobile.matches && (variantControl || materialControl)) {
      queueUserJump(root, variantControl);
    }
  }, true);

  document.addEventListener('optionValueSelectionChange', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    var root = sectionId ? document.getElementById('MainProduct-' + sectionId) : null;
    if (root) syncGalleryArrows(root);
  });

  document.addEventListener('afterVariantChanged', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    var root = sectionId ? document.getElementById('MainProduct-' + sectionId) : null;
    if (!root) return;

    syncGalleryArrows(root);
    var entry = pending.get(root);
    if (!entry || !mobile.matches) return;

    window.clearTimeout(entry.fallback);
    window.clearTimeout(entry.afterUpdate);
    // The theme focuses the chosen dropdown after the variant fetch completes.
    // Scroll slightly afterwards so focus does not pull the page back down.
    entry.afterUpdate = window.setTimeout(function () {
      if (pending.get(root) === entry) jumpToImage(root);
    }, 120);
  });

  function initialise() {
    document.querySelectorAll(rootSelector).forEach(syncGalleryArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', initialise);
})();
